import React, { useEffect } from 'react';

const CatalogoPage = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://online.flippingbook.com/EmbedScriptUrl.aspx?m=redir&hid=978089453';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Catálogo R&M 2023</h1>
      <a
        href="https://online.flippingbook.com/view/978089453/"
        className="fbo-embed"
        data-fbo-id="a44ae4018c"
        data-fbo-ratio="3:2"
        data-fbo-lightbox="yes"
        data-fbo-width="100%"
        data-fbo-height="auto"
        data-fbo-version="1"
        style={{ maxWidth: '100%' }}
      >
        Ver catálogo interactivo
      </a>
    </div>
  );
};

export default CatalogoPage;
